import { render, staticRenderFns } from "./DocumentRetention.vue?vue&type=template&id=54f96576&scoped=true&"
import script from "./DocumentRetention.vue?vue&type=script&lang=ts&"
export * from "./DocumentRetention.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentRetention.vue?vue&type=style&index=0&id=54f96576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f96576",
  null
  
)

export default component.exports